import { render, staticRenderFns } from "./FormAulaTeorica.vue?vue&type=template&id=2d42da66"
import script from "./FormAulaTeorica.vue?vue&type=script&lang=js"
export * from "./FormAulaTeorica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports